<!-- LEFT SIDE -->
<div id="login-container">
  <div class="info-container">
    <div class="info-content">
      <img src="/assets/images/logo.png" alt="" class="logo" />
      <h1>{{ 'form_login_app.header_title' | translate }}</h1>
    </div>
  </div>

  <!-- RIGHT SIDE -->
  <div class="form-container">
    <!-- Alert box -->
    <div class="alert al-danger" *ngIf="showAlertBox">
      <img class="x-mark" src="/assets/icons/x-mark.svg" (click)="showAlertBox = !showAlertBox" />
      <p>{{ alertMessage }}</p>
    </div>

    <form class="login-form" #loginForm="ngForm" (ngSubmit)="onLoginClick()" novalidate>
      <!-- Email signin -->
      <mat-form-field class="full-width" hideRequiredMarker>
        <mat-label class="place-holder">{{ 'form_login_app.form_login.email' | translate }}</mat-label>
        <input type="text" matInput name="username" [(ngModel)]="username" [disabled]="submiting" #email="ngModel"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" required autofocus autocomplete="off" />
        <mat-error *ngIf="email.errors?.['required'] && email.touched">
          {{ "form_register_app.form_register.email_required" | translate }}
        </mat-error>
        <mat-error *ngIf="email.errors?.['pattern']">
          {{ "form_register_app.form_register.email_regex" | translate }}
        </mat-error>
      </mat-form-field>

      <!-- password -->
      <mat-form-field class="full-width" hideRequiredMarker>
        <mat-label class="place-holder">{{ 'form_login_app.form_login.password' | translate }}</mat-label>
        <input matInput name="password" [(ngModel)]="password" [disabled]="submiting"
          [type]="hide ? 'password' : 'text'" #pass="ngModel" required autocomplete="off" />
        <mat-icon matSuffix (click)="hide = !hide">
          {{ hide ? "visibility_off" : "visibility" }}
        </mat-icon>
        <mat-error *ngIf="pass.invalid || pass.untouched">
          {{ 'form_login_app.form_login.password_required' | translate }}
        </mat-error>
      </mat-form-field>

      <div class="login-form-opt-container">
        <div class="remember-container">
          <mat-checkbox color="primary" name="isRememberMe" [(ngModel)]="isRememberMe">
            <span>{{ 'form_login_app.form_login.rememberme' | translate }}</span>
          </mat-checkbox>
        </div>

        <!-- <div class="forget-pass-container" NgIf="false">
          <a href="/forget-password">{{ 'form_login_app.form_login.forget_password' | translate }}</a>
        </div> -->
      </div>

      <button mat-flat-button class="btn btn-sign-in" [disabled]="loginForm.form.invalid" [disabled]="submiting"
        [class]="{ 'btn-disbled': loginForm.form.invalid || submiting }">
        <span class="btn-content">{{ 'form_login_app.form_login.signin_button' | translate }}</span>
      </button>
      <div class="login-form-info">
        <p>{{ 'form_login_app.form_login.register_label' | translate }}</p>
        <a routerLink="/register">{{ 'form_login_app.form_login.register_link' | translate }}</a>
      </div>
    </form>
  </div>
</div>